/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S7_HeadingInputs */

const tr_mesafeli_s7_heading = /** @type {(inputs: Mesafeli_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Cayma Hakkı ve Hizmet Başlangıcı`)
};

const en_mesafeli_s7_heading = /** @type {(inputs: Mesafeli_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Right of Withdrawal and Commencement of the Service`)
};

const de_mesafeli_s7_heading = /** @type {(inputs: Mesafeli_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Widerrufsrecht und Beginn der Leistung`)
};

const ru_mesafeli_s7_heading = /** @type {(inputs: Mesafeli_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Право на отказ от договора и начало оказания услуги`)
};

/**
* | output |
* | --- |
* | "7. Right of Withdrawal and Commencement of the Service" |
*
* @param {Mesafeli_S7_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s7_heading = /** @type {((inputs?: Mesafeli_S7_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S7_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s7_heading(inputs)
	if (locale === "de") return de_mesafeli_s7_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s7_heading(inputs)
	return tr_mesafeli_s7_heading(inputs)
});